import * as tslib_1 from "tslib";
import { CouponPage, CouponType, DestinationType, ProductType, ResponseStatus, } from '../../globalTypes';
import { ProductTypeHelper, ProgressBarStep, store } from '../../index';
import { CouponActionTypes } from '../types/ActionTypes';
import CouponsSession from './CouponSession/CouponsSession';
var Coupons = /** @class */ (function () {
    function Coupons() {
    }
    Coupons.prepareCouponStateAsync = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var market, couponReference, couponsSession, couponSessionObjectPromise;
            return tslib_1.__generator(this, function (_a) {
                market = store.getState().websiteState.app.url.context.market;
                couponReference = Coupons.getCouponForPage();
                if (couponReference) {
                    this.setCouponLastSeenCookie(couponReference.couponName);
                    couponsSession = CouponsSession.getInstance();
                    couponSessionObjectPromise = couponsSession.getCouponObjectFromUserSession(couponReference, market);
                    couponSessionObjectPromise.then(function (couponSessionObject) {
                        var receiveCouponAction = {
                            couponReference: couponReference,
                            type: CouponActionTypes.RECEIVE_COUPON,
                            couponCode: couponSessionObject.code,
                            validUntil: couponSessionObject.validUntil
                        };
                        store.dispatch(receiveCouponAction);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * @toDo: Selim refactor website direct call CouponsSession.ts
     */
    Coupons.isExitIntentShownAlready = function () {
        var couponsSession = CouponsSession.getInstance();
        return couponsSession.isExitIntentShownAlready();
    };
    /**
     * @toDo: Selim refactor website direct call CouponsSession.ts
     */
    Coupons.saveExitIntentImpressionTime = function () {
        var couponsSession = CouponsSession.getInstance();
        return couponsSession.saveExitIntentImpressionTime();
    };
    Coupons.isCouponForPageExist = function () {
        return !!this.getCouponForPage();
    };
    Coupons.getCouponForPage = function () {
        var lturState = store.getState();
        if (lturState && lturState.websiteState &&
            lturState.websiteState.app &&
            lturState.websiteState.app.currentStep &&
            lturState.websiteState.app.url &&
            lturState.websiteState.app.url.context &&
            lturState.websiteState.app.url.context.productType &&
            lturState.coreState) {
            var page = Coupons.getCouponPageFromCurrentState(lturState);
            var productType = lturState.websiteState.app.url.context.productType;
            var coreStateGroup = ProductTypeHelper.mapToCoreStateGroup(productType);
            if (lturState.coreState[coreStateGroup]) {
                var responseStatus = void 0;
                var response = void 0;
                if (CouponPage.WORLD_WIDE === page || CouponPage.HOTEL_LIST === page) {
                    // Check for group response
                    var destinationType = DestinationType.HOTEL_LIST;
                    response = lturState.coreState[coreStateGroup].groups.get(destinationType);
                    responseStatus = response.status;
                }
                else {
                    // Check for product response
                    var destinationType = DestinationType.DESTINATION;
                    if (lturState.websiteState.app.url.context.productType === ProductType.HOTEL) {
                        response = lturState.coreState[coreStateGroup].offers.get('default');
                    }
                    else {
                        response = lturState.coreState[coreStateGroup].flightAlternatives.get('default');
                    }
                    responseStatus = response.status;
                }
                if (ResponseStatus.SUCCEED === responseStatus) {
                    return Coupons.filterAndGetCouponReferenceFromResponse(response, page);
                }
            }
        }
        return null;
    };
    Coupons.getCouponLastSeenCookie = function () {
        if (document && document.cookie && document.cookie.length > 0) {
            var cookieValues = document.cookie.split('; ');
            if (cookieValues && cookieValues.length > 0) {
                var couponLastSeenCookieValues = cookieValues.filter(function (val) { return val.startsWith('couponLastSeen='); });
                if (couponLastSeenCookieValues && couponLastSeenCookieValues.length > 0) {
                    var couponLastSeenCookieValue = couponLastSeenCookieValues[0];
                    var couponLastSeenCookieKeyValue = couponLastSeenCookieValue.split('=');
                    if (couponLastSeenCookieKeyValue && couponLastSeenCookieKeyValue.length > 1) {
                        return couponLastSeenCookieKeyValue[1];
                    }
                }
            }
        }
        return null;
    };
    Coupons.setCouponLastSeenCookie = function (couponName) {
        var domain = window.location.hostname.substr(window.location.hostname.indexOf('.') + 1);
        document.cookie = 'couponLastSeen=' + encodeURIComponent(couponName) + '; path=/; domain=' + domain;
    };
    Coupons.getCouponPageFromCurrentState = function (lturState) {
        //@ts-ignore
        var currentStep = lturState.websiteState.app.currentStep;
        switch (currentStep) {
            case ProgressBarStep.DESTINATION: {
                return CouponPage.WORLD_WIDE;
                break;
            }
            case ProgressBarStep.HOTEL_LIST: {
                return CouponPage.HOTEL_LIST;
                break;
            }
            case ProgressBarStep.INFO_AND_DATES: {
                return CouponPage.HOTEL_DETAILS;
                break;
            }
            default: {
                return CouponPage.BOOKING;
            }
        }
    };
    Coupons.filterAndGetCouponReferenceFromResponse = function (response, page) {
        if (response.references !== void 0 && response.references !== null
            && response.references['coupon'] !== void 0 && response.references['coupon'] !== null && Object.keys(response.references['coupon']).length > 0) {
            // We have some coupon candidates, now filter and prioritize them and return the matching coupon
            var validCoupons = Object.values(response.references['coupon']).filter(function (couponReference) { return Coupons.isCouponMatchesCriteria(couponReference, page); });
            var selectedCoupon = Coupons.getBestMatchingCoupon(validCoupons);
            return selectedCoupon;
        }
        return null;
    };
    Coupons.isCouponMatchesCriteria = function (coupon, page) {
        return (coupon.pages === void 0 || coupon.pages === null || coupon.pages.includes(page));
    };
    Coupons.getBestMatchingCoupon = function (coupons) {
        var couponLastSeenCookie = this.getCouponLastSeenCookie();
        // Prefer action codes over coupons, even if there is a lastSeenCookie set
        var actionCodes = coupons.filter(function (coupon) { return coupon.couponType === CouponType.ACTIONCODE; });
        if (actionCodes && actionCodes.length > 0) {
            return actionCodes[0];
        }
        // If no action codes available check lastSeenCookie and use that coupon if available
        if (couponLastSeenCookie) {
            var lastSeenCouponArray = coupons.filter(function (coupon) { return coupon.couponName === couponLastSeenCookie; });
            if (lastSeenCouponArray && lastSeenCouponArray.length > 0) {
                return lastSeenCouponArray[0];
            }
        }
        // In other cases choose first coupon from the ordered coupon list
        return coupons[0];
    };
    return Coupons;
}());
export default Coupons;
